import React from "react";

import "./NotFound.scss";

const NotFound = () => {
  return (
    <>
      <div className="error-container">
        <h5>404 Not found</h5>
      </div>
    </>
  );
};

export default NotFound;
